import { render, staticRenderFns } from "./Barge.vue?vue&type=template&id=4e9fab56&"
import script from "./Barge.vue?vue&type=script&lang=ts&"
export * from "./Barge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports